import { render, staticRenderFns } from "./doctorQuery.vue?vue&type=template&id=27e23ecc&scoped=true&"
import script from "./doctorQuery.vue?vue&type=script&lang=js&"
export * from "./doctorQuery.vue?vue&type=script&lang=js&"
import style0 from "./doctorQuery.vue?vue&type=style&index=0&id=27e23ecc&prod&lang=less&"
import style1 from "./doctorQuery.vue?vue&type=style&index=1&id=27e23ecc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e23ecc",
  null
  
)

export default component.exports